export function toStringArray(value: string | string[] | undefined | null): string[] | undefined {
  if (!value) return undefined;
  return Array.isArray(value) ? value : [value];
}

export async function fetchAllPaginated<T>(
  fetchFn: (offset: number, limit: number) => Promise<{ items: T[] }>,
  batchSize = 100,
  maxResults = 1000,
): Promise<T[]> {
  const results: T[] = [];

  for (let offset = 0; offset < maxResults; offset += batchSize) {
    const response = await fetchFn(offset, batchSize);
    if (!response.items.length) break;

    results.push(...response.items);

    if (response.items.length < batchSize) break; // no more pages
  }

  return results.slice(0, maxResults);
}
